import {Reducer} from "redux";
import {
    ClientProjectListAction,
    ClientProjectListActionType,
    ICallbackGetAllByClientProjectListAction,
} from "../action/client_projects_action";
import {ClientProjectListState} from "../store/client_projects_state";

const initialState: ClientProjectListState = {
    projects: [],
    projectCount: 0,
    companies: [],
    isLoading: false,
};

const clientProjectListReducer: Reducer<ClientProjectListState> = (
    state = initialState,
    action: ClientProjectListAction
): ClientProjectListState => {
    switch (action.type) {
        case ClientProjectListActionType.REQUEST_GET_ALL_BY_CLIENT_PROJECT_LIST: {
            return Object.assign({}, state, {
                projects: state.projects,
                projectCount: state.projectCount,
                companies: state.companies,
                isLoading: true,
            });
        }
        case ClientProjectListActionType.CALLBACK_GET_ALL_BY_CLIENT_PROJECT_LIST: {
            const _action = action as ICallbackGetAllByClientProjectListAction;
            if (action.isSuccess) {
                return Object.assign({}, state, {
                    projects: _action.item ? _action.item.projects : [],
                    projectCount: _action.item ? _action.item.projectCount : 0,
                    companies: _action.item ? _action.item.companies : [],
                    isLoading: false,
                });
            } else {
                return Object.assign({}, state, {
                    projects: state.projects,
                    projectCount: state.projectCount,
                    companies: state.companies,
                    isLoading: false,
                });
            }
        }

        case ClientProjectListActionType.REQUEST_COPY_PROJECT: {
            return Object.assign({}, state, {
                projects: state.projects,
                projectCount: state.projectCount,
                companies: state.companies,
                isLoading: true,
            });
        }
        case ClientProjectListActionType.CALLBACK_COPY_PROJECT: {
            if (action.isSuccess) {

                return Object.assign({}, state, {
                    projects: [action.item!.project, ...state.projects],
                    projectCount: state.projectCount + 1,
                    companies: state.companies,
                    isLoading: false,
                });
            } else {
                return Object.assign({}, state, {
                    projects: state.projects,
                    projectCount: state.projectCount,
                    companies: state.companies,
                    isLoading: false,
                });
            }
        }

        default:
            return state;
    }
};

export default clientProjectListReducer;



// WEBPACK FOOTER //
// ./src/presentation/reducer/client_projects_reducer.ts